import moment from 'moment';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { IReducer } from '../../../../../../redux/configureStore';
import { getLimitList } from '../../../../../../redux/fetchActions/legadoPage/limitApp';
import SearchButton from '../../../../../../shared/components/buttons/SearchButton';
import Filter from '../../../../../../shared/components/Filter';
import SetFinalDate from './components/SetFinalDate';
import SetInitialDate from './components/SetInitialDate';
import SetPartner from './components/SetPartner';

function LimitFilter() {
  const dispatch = useDispatch();

  const limitFilterState = useSelector(
    (reducer: IReducer) => reducer.outstandigDebitsFilter
  );

  const profileNivelState = useSelector(
    (reducer: IReducer) => reducer.partnerProfile
  );

  function dispathData() {
    if (profileNivelState.nivel !== 2) {
      dispatch(
        getLimitList(
          profileNivelState.idLegado,
          limitFilterState.initialDate,
          limitFilterState.finalDate
        )
      );
    } else {
      dispatch(
        getLimitList(
          limitFilterState.partner,
          limitFilterState.initialDate,
          limitFilterState.finalDate
        )
      );
    }
  }

  function searchFare() {
    if (
      moment(limitFilterState.initialDate) > moment(limitFilterState.finalDate)
    ) {
      return Swal.fire({
        icon: 'error',
        title: 'A data inicial não pode ser maior que a data final!',
        confirmButtonText: 'Tentar novamente',
      });
    }
    return dispathData();
  }

  return (
    <Filter.Default>
      <SetPartner />
      <SetInitialDate />
      <SetFinalDate />
      <SearchButton
        onClick={() => searchFare()}
        justifyContent="center"
        width="10rem"
      />
    </Filter.Default>
  );
}

export default LimitFilter;
